<template lang="html">
  <div>
    <nav class="fsd-modal__tabs">
      <button
        v-for="(itemName, item) in head"
        :key="item"
        v-click-track="{ event_element: `${item}_tab`, action_type: 'select' }"
        class="fsd-modal__tab"
        :class="{ 'fsd-modal__tab--active': item == currentTab }"
        type="button"
        @click="onTabChange(item)"
      >
        {{ itemName }}
      </button>
    </nav>
    <render
      v-for="(_itemName, item) in head"
      v-show="item === currentTab"
      :key="item"
      :what="$slots[item]"
    />
    <slot v-if="$slots['footer']" name="footer" />
  </div>
</template>

<script>
import Vue from 'vue'

// eslint-disable-next-line vue/one-component-per-file
const Render = Vue.extend({
  props: { what: { required: true, type: Array } },
  render(h) {
    return h('div', this.what)
  }
})

// eslint-disable-next-line vue/one-component-per-file
export default {
  components: { Render },
  props: {
    head: { required: true, type: Object },
    initialTab: { required: true, type: String }
  },
  data: () => ({
    currentTab: null
  }),
  mounted() {
    this.currentTab = this.initialTab
  },
  methods: {
    onTabChange(item) {
      this.currentTab = item
      this.$emit('tabChanged', item)
    }
  }
}
</script>

<style lang="css" scoped></style>
